import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=6f0c39c8"
import script from "./paymentMethod.vue?vue&type=script&lang=js"
export * from "./paymentMethod.vue?vue&type=script&lang=js"
import style0 from "./paymentMethod.vue?vue&type=style&index=0&id=6f0c39c8&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports